/**
 * AppShell — brand-teal header common to every page.
 *
 * Header is split into three regions:
 *   - Brand wordmark + product label (left)
 *   - Primary nav: Clinics, Admin (center-ish)
 *   - User pill (right) — placeholder until real auth is wired
 *
 * Admin nav links are always visible in dev (auth-bypass identity has
 * both RCM_OPS_REVIEWER and RCM_OPS_SENIOR_REVIEWER per handoff §1).
 * Per the handoff, the React role check is UX-only; backend enforces.
 */
import { NavLink, Outlet } from "react-router-dom";

function navLinkClass({ isActive }: { isActive: boolean }) {
  return [
    "px-3 py-1.5 rounded text-sm transition-colors",
    isActive
      ? "bg-white/15 text-white font-semibold"
      : "text-white/85 hover:text-white hover:bg-white/10",
  ].join(" ");
}

export function AppShell() {
  return (
    <div className="min-h-screen flex flex-col">
      <header className="bg-brand-header text-white h-14 flex items-center px-6 gap-6">
        <span className="text-lg font-semibold">
          irisMD <span className="opacity-70 font-normal">· Quality</span>
        </span>
        <nav className="flex items-center gap-1" aria-label="Primary">
          <NavLink to="/clinics" className={navLinkClass}>
            Clinics
          </NavLink>
          <NavLink to="/admin/clinics" className={navLinkClass}>
            Admin · Clinics
          </NavLink>
          <NavLink to="/admin/benchmarks" className={navLinkClass}>
            Admin · Benchmarks
          </NavLink>
          <NavLink to="/admin/scoring-runs" className={navLinkClass}>
            Admin · Scoring runs
          </NavLink>
        </nav>
        <div className="ml-auto flex items-center gap-3 text-sm">
          <span className="opacity-90">MIPS Dashboard · V1</span>
          <span
            className="inline-flex items-center gap-2 rounded-full bg-white/15 px-2.5 py-1"
            title="Authenticated user (dev: bypass identity)"
          >
            <span className="inline-flex h-6 w-6 items-center justify-center rounded-full bg-white text-xs font-semibold text-brand-header">
              CA
            </span>
            <span className="opacity-95">Chelsea A.</span>
          </span>
        </div>
      </header>
      <main className="flex-1 max-w-[1600px] mx-auto w-full px-6 py-6">
        <Outlet />
      </main>
    </div>
  );
}
